import { render, staticRenderFns } from "./FishcarReports.vue?vue&type=template&id=80590440"
import script from "./FishcarReports.vue?vue&type=script&lang=js"
export * from "./FishcarReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports